import { uniqBy } from 'lodash';
import { IAssembly } from 'src/interfaces';

import { SUMMARY_PAGE_COLUMN } from './BulkReplaceSummaryPage.interface';

export const columns = [
  {
    label: 'Assembly name',
    key: SUMMARY_PAGE_COLUMN.ASSEMBLY_NAME,
    width: 340,
  },
  { label: 'Channel type', key: SUMMARY_PAGE_COLUMN.CHANNEL_TYPE, width: 270 },
  {
    label: 'No of location groups',
    key: SUMMARY_PAGE_COLUMN.NO_OF_LOCATION_GROUPS,
    width: 270,
  },
  { label: '', key: SUMMARY_PAGE_COLUMN.TAGS, width: 500 },
  { label: '', key: SUMMARY_PAGE_COLUMN.TOGGLE, width: 70 },
];

export const groupAssembliesbyLevel = (
  assemblies?: IAssembly[],
  allAssemblies?: IAssembly[],
) => {
  if (!assemblies) {
    return;
  }

  const assembleTree = assemblies?.reduce(
    (acc: IAssembly[], assembly: IAssembly) => {
      const parentId = assembly.variation_parent_id;

      if (parentId) {
        const parentAssembly = assemblies?.find((item) => item.id === parentId);
        if (parentAssembly) {
          parentAssembly.childrenAssemblies = uniqBy(
            [...parentAssembly.childrenAssemblies, assembly],
            assembly.id,
          ).sort((a, b) => a.name.localeCompare(b.name));
        } else {
          acc.push(assembly);
        }
      } else {
        const variations = allAssemblies?.filter(
          (variation) => variation.variation_parent_id === assembly.id,
        );
        if (variations)
          assembly.childrenAssemblies = variations.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
        acc.push(assembly);
      }

      return acc;
    },
    [],
  );

  return assembleTree.flat().sort((a, b) => a.name.localeCompare(b.name));
};

export const chooseTag = () => {
  return 'Component has been successfully staged';
};

export const getSelectedAssembiles = (
  assembliesIds: number[],
  assemblies?: IAssembly[],
) => {
  const selectedassemblies = assemblies?.filter((assembly) =>
    assembliesIds.includes(assembly.id),
  );

  return selectedassemblies?.sort((a, b) => a.name.localeCompare(b.name));
};
